<template>
  <div class="text-center">
    prikazujem
    <!-- <iframe
        title="Embedded PDF"
        src={pdfDataUri}
        width="100%"
        height="100%"
      >
        <p>Your browser does not support iframes. <a href={pdfDataUri} download="document.pdf">Download the PDF</a> instead.</p>
      </iframe> -->

    <!-- <v-dialog
      v-model="dialog"
      :scrim="false"
      persistent
      width="auto"
    >
      <img :src="`data:image/pdf;base64,${image}`" onclick="dialogSwitch"/>
    </v-dialog> -->
  </div>
</template>

<script>


export default {
  name: '',
  props: [ 'base64Content' ],
  data: ()=> ({
    dialog: true,
    pdfDataUri: null
  }),
  mounted() {
    console.log('prikazujem image', this.base64Content)
    this.pdfDataUri = `data:application/pdf;base64,${this.base64Content}`
  },
  created () {
    this.dialog = this.showDialog
  },
  dialogSwitch() {
    this.dialog = !this.dialog
  }


}

</script>